import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from "./Components/Navbar/Navbar";
import Home from "./Components/Home";
import { homeData } from "./data";
import AreasAtuacao from "./Components/AreasAtuacao";
import Carreira from "./Components/Carreira";
import Contato from "./Components/Contato";
import Footer from "./Components/Footer";
import "./styles/styles.sass";
import 'animate.css'

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home data={homeData} />} />
        <Route path="/areasdeatuacao" element={<AreasAtuacao />} />
        <Route path="/carreira" element={<Carreira />} />
        <Route path="/contato" element={<Contato />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
